import type {RumTimeMark} from '../types'
import {getRumGlobal, parseRumPageVar} from '../utils'

type RumGlobal = NonNullable<ReturnType<typeof getRumGlobal>>

const finalizeRumCounterMetrics = (rum: RumGlobal) => {
  rum.sendTrafficData()
  rum.finalizeLayoutShiftScore()
  rum.finalizeLargestContentfulPaint()
  rum.finalizeINP?.()

  if ((rum as any)._tti?.fired === false) {
    rum.sendTTI?.(undefined, rum.getTime())
  }
}

export const sendRumTimeMark = (name: RumTimeMark) => getRumGlobal()?.sendTimeMark?.(name)

export const finalizeRumCounter = () => {
  const rum = getRumGlobal()

  if (rum) {
    // @ts-expect-error Принудительно делаем RUM-метрики непривязанными
    const disconnectTrencher = () => rum.setVars?.({rum_id: undefined})
    const [serviceName] = parseRumPageVar()

    finalizeRumCounterMetrics(rum)

    if (serviceName === 'account') {
      rum.resetINP?.()
    }

    setTimeout(() => disconnectTrencher())
  }
}
